// aswin
import React, { Fragment, useRef } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

// Header
import Header from "../component/Header";

// SideNav
import SideBar from "../component/SideNav";

// Footer
import Footer from "../component/Footer";

// Login
import Login from "../screens/Auth/Login";

// UnAuthorized
import UnAuthorized from "../screens/UnAuthorized";

// Forgot Password
import ForgotPassword from "../screens/Auth/ForgotPassword";

// VerifyOTP
import Verifyotp from "../screens/Auth/Verifyotp";

// Reset Password
import Resetpassword from "../screens/Auth/Resetpassword";

// Dashboard
import Default from "../screens/Dashboard";

// UserProfile
import ViewUserProfile from "../screens/profile/index";
import UserEditPorfile from "../screens/profile/EditProfile";
import ChangePassword from "../screens/profile/ChangePassword";

// User
import User from "../screens/Users/index";
import EditUser from "../screens/Users/EditUser";
import ViewUser from "../screens/Users/ViewUser";
import AddNewUser from "../screens/Users/AddNewUser";

// Property
import Property from "../screens/Property/index";
import AddNewProperty from "../screens/Property/AddNewProperty";
import AddNewPropNext from "../screens/Property/AddNewPropNext";
import PropertyStepThird from "../screens/Property/PropertyStepThird";
import PropertyStepFourth from "../screens/Property/PropertyStepFourth";
import EditPropertyStepThird from "../screens/Property/EditPropertyStepThird";
import EditProperty from "../screens/Property/EditProperty";
import EditPropertyStepFourth from "../screens/Property/EditPropertyStepFourth";
import EditPropertyNext from "../screens/Property/EditPropertyNext";
import ViewProperty from "../screens/Property/ViewProperty";
import ViewPropertyImage from "../screens/Property/ViewPropertyImage";

// Role
import Roles from "../screens/Roles/index";
import EditRoles from "../screens/Roles/EditRoles ";
import AddNewRoles from "../screens/Roles/AddNewRoles";

// Module
import Module from "screens/Module";

// Master
import Master from "screens/Master";

// Channel Partner
import ChannelPartner from "../screens/channel_partner";
import ViewChannelPartner from "../screens/channel_partner/ViewChannelPartner";
import ViewAgentDetails from "../screens/channel_partner/ViewAgentDetails";
import AddNewCP from "../screens/channel_partner/AddNewCP";
import AgentList from "../screens/channel_partner/AgentList";
import CpSmList from "../screens/channel_partner/CpSmList";

// Visitor
import Visitor from "../screens/Visitor";
import EditVisitor from "../screens/Visitor/EditVisitor";
import EditVisitorNext from "screens/Visitor/EditVisitorNext";
import EditVisitorNext1 from "screens/Visitor/EditVisitorNext1";
import ViewVisitor from "../screens/Visitor/ViewVisitor";
import BulkUploadImgCsv from "screens/Visitor/BulkUploadImgCsv";
import UploadImage from "screens/Visitor/UploadImage";
import UploadCsv from "screens/Visitor/UploadCsv";
import EditVisitorNextDraft from "../screens/Visitor/EditVisitorNextDraft"

// Appointment
import Appointment from "../screens/Appointment";
import ViewAppointment from "../screens/Appointment/ViewAppointment";
import EditAppointment from "screens/Appointment/EditAppointment";
import AddAppointment from "screens/Appointment/AddAppointment";
import UpdateAppointmentStatus from "screens/Appointment/updateAppointmentStatus";

// New Upload
import NewUpload from "screens/NewUpload";
import CreateVisitor from "screens/NewUpload/CreateVisitor";
import CreateVisitorNext from "screens/NewUpload/CreateVisitorNext";
import CreateVisitorNext1 from "screens/NewUpload/CreateVisitorNext1";

// Verify Lead
import VerifyLead from "screens/VerifyLead";
import ViewVerifyLead from "screens/VerifyLead/ViewVerifyLead";
import CreateLead from "screens/VerifyLead/createLead";
import CreateLeadNext from "screens/VerifyLead/createLeadNext";
import CreateLeadNext1 from "screens/VerifyLead/createLeadNext1";

// Chat Screen
import ChatScreen from "../screens/Chat";
import ChatScreenNext from "../screens/Chat/chatNext";

// Followup
import FollowUp from "../screens/Followup";
import AllFollowUP from "screens/Followup/AllFollowUp";
import ViewFollowUp from "../screens/Followup/ViewFollowUp";
import EditFollowup from "screens/Followup/EditFollowup";
import UpdateStatusFollow from "screens/Followup/UpdateStatusfollow";
import AppointmentFollowup from "../screens/Followup/AppointmentFollowup";
import TodayFollowupIndex from "../screens/Followup/TodayFollowupIndex";

// Support Forum
import SupportForum from "../screens/SupportForum";
import AddNewSupportForum from "../screens/SupportForum/AddNewSupportForum";
import EditSupportForum from "../screens/SupportForum/EditSupportForum";
import ViewSupportForum from "../screens/SupportForum/ViewSupportForum";
import ViewSupportForumGallary from "screens/SupportForum/viewSupportForumGallary";

// Support Ticket
import SupportTicket from "../screens/SupportTicket";
import ViewSupportTicket from "../screens/SupportTicket/ViewSupportTicket";
import UpdateStatus from "screens/SupportTicket/UpdateStatus";
import EditReplyTicket from "../screens/SupportTicket/EditReplyTicket";
import AddEditRaiseTicket from "screens/SupportTicket/AddEditRaiseTicket";

// Configuration_Setting
import ConfigurationEmail from "screens/Configuration_Setting/Email";
import ConfigurationMessage from "screens/Configuration_Setting/Message";
import NotificationMapKey from "screens/Configuration_Setting/NotificationMapKey";

// Booking
import BookingList from "../screens/booking/BookingLIst";
import ViewBooking from "../screens/booking/ViewBooking";

// Registration
import Registration from "../screens/registration";
import ViewRegistration from "../screens/registration/ViewRegistration";
import ViewPropertyNextPage from "../screens/Property/ViewNextProperty";

// public lead
import Lead from "../screens/PublicLead/index";

// Privacy Policy
import PrivacyPolicy from "../screens/privacy_policy";
import PrivacyPolicyUpdate from "../screens/Configuration_Setting/PrivacyPolicyEdit";

// Term_condition
import TermAndCondition from "../screens/termAndcondition";

// report detail
import ReportDetail from "../screens/Report/index";
import ReportManage from "../screens/Report/reportMange";
import UserActivityReport from "../screens/Report/userActivityReport";
// import ProjectReportPage from "../screens/Report/webReport"
import ProjectDetailsReportPage from "../screens/Report/projectDetailsReport";
import AppointmentSiteVisit from "../screens/Appointment/AppointmentSiteVisit";

// Support
import Support from "../screens/support/index";

// User Announcement
import UserAnnouncement from "../screens/UserAnnouncement/index";

//newDashboard
// import NewDashboard from "../screens/Dashboard/NewDashboard";

import { useDispatch, useSelector } from "react-redux";
import { handleDetailResponse, handleListResponse, isEmpty } from "utils/utils";
import firebaseService from "utils/firebaseConfig";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { firebaseIdUpdate } from "reduxStore/action/authActions";
import Dashboard1 from "screens/Dashboard/Dashboard1";
import DepositonReport from "../screens/Report/DepositionReport";
import ChanelPartnerReport from "../screens/Report/ChanelPartnerReport";
import Revisit from "screens/Appointment/Revisit";
import AddBooking from "screens/booking/AddBooking";
import ClosingManagerList from "screens/ClosingManager/ClosingManagerList";
import ClosingManagerDetails from "screens/ClosingManager/ClosingManagerDetails";
import SourcingManagerList from "screens/SourcingManager/SourcingManagerList";
import SourcingManagerDetails from "screens/SourcingManager/SourcingManagerDetails";
import CpAppointmentList from "screens/CpAppointment/CpAppointmentList";
import AppointmentDetailsCp from "screens/CpAppointment/AppointmentDetailsCp";
import AddAppointmentWithCp from "screens/CpAppointment/AddAppointmentWithCp";
import TodayAppointment from "screens/Appointment/TodayAppointment";
import SupportRequest from "screens/SupportTicket/SupportRequest";
import CancelBookingList from "screens/booking/CancelBookingList";
import PdrReport from "screens/Report/PdrReport";
import ReportUser from "screens/Report/ReportUser";
import CpAppointmentReport from "screens/CpAppointmentReport/CpAppointmentReport";
import ChannelPartnerAppointmentReport from "screens/CpAppointmentReport/ChannelPartnerAppointmentReport"
import ScheduledActivityFollowup from "../screens/Followup/ScheduledActivityFollowup";
// import Dashboard2 from "screens/Dashboard/Dashboard2";
// import Dashboard3 from "screens/Dashboard/Dashboard3";

function Routers() {
  const dispatch = useDispatch();
  const firebaseLoginRef = useRef(true);
  const updateFirebaseId = (uid, response) => {
    firebaseLoginRef.current = false;
    dispatch(
      firebaseIdUpdate({
        firebase_id: uid,
        data: response,
        isLoadMore: true,
      })
    );
  };
  const createUserWithFirebase = (result, response) => {
    createUserWithEmailAndPassword(
      firebaseService.auth,
      result?.email,
      "123456"
    )
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        result.firebase_id = user.uid;
        response.data = result;
        updateFirebaseId(user.uid, response);
      })
      .catch((err) => {
        if (err.code === "auth/email-already-in-use") {
          signInWithWithFirebase(result, response);
        }
      });
  };
  const signInWithWithFirebase = (result, response) => {
    signInWithEmailAndPassword(firebaseService.auth, result?.email, "123456")
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        result.firebase_id = user.uid;
        response.data = result;
        updateFirebaseId(user.uid, response);
        // ...
      })
      .catch((err) => {
        // if (err.code === 'auth/user-not-found') {
        //   createUserWithFirebase(result,response);
        // }
      });
  };
  const isAuth = useSelector((state) => {
    const { response, authToken } = state.login;
    if (response && authToken) {
      const result = handleDetailResponse(response.data);
      const user = firebaseService.auth.currentUser;
      if (!user) {
        if (firebaseLoginRef?.current) {
          createUserWithFirebase(result, response);
        }
      }
      // if (isEmpty(result?.firebase_id)) {
      // } else {
      //   const user = firebaseService.auth.currentUser;
      //   if (!user) {
      //     if (firebaseLoginRef?.current) {
      //      signInWithWithFirebase(result,response);
      //     }
      //   }
      // }
      return true;
    } else {
      return false;
    }
  });
  return (
    <div className="App">
      <Fragment>
        <Routes>
          {/* Login */}
          <Route path={`${process.env.PUBLIC_URL}/`} element={<Login />} />
          <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />

          {/* UnAuthorized */}
          <Route
            path={`${process.env.PUBLIC_URL}/unauthorized`}
            element={<UnAuthorized />}
          />

          {/* ForgotPassword */}
          <Route
            path={`${process.env.PUBLIC_URL}/forgotpassword`}
            element={<ForgotPassword />}
          />

          {/* VerifyOTP */}
          <Route
            path={`${process.env.PUBLIC_URL}/verifyotp`}
            element={<Verifyotp />}
          />

          {/* Reset Password */}
          <Route
            path={`${process.env.PUBLIC_URL}/resetpassword`}
            element={<Resetpassword />}
          />

          {/* Authuser */}
          <Route
            path={`${process.env.PUBLIC_URL}/*`}
            element={isAuth ? <AuthUsers /> : <Navigate to="/login" />}
          />

          {/* Public Lead  */}
          <Route path={`${process.env.PUBLIC_URL}/lead`} element={<Lead />} />
          {/* Privacy Police  */}
          <Route
            path={`${process.env.PUBLIC_URL}/privacypolicy`}
            element={<PrivacyPolicy />}
          />
          {/* terms_and_condition */}
          <Route
            path={`${process.env.PUBLIC_URL}/termandcondition`}
            element={<TermAndCondition />}
          />

          {/* report details */}
          {/* {isAuth ? null : (
            <Route
              path={`${process.env.PUBLIC_URL}/report`}
              element={<ReportDetail isAuth={isAuth} />}
            />
          )}
          {isAuth ? null : (
            <Route
              path={`${process.env.PUBLIC_URL}/kpi_tracker_report`}
              element={<ReportManage isAuth={isAuth} />}
            />
          )} */}
          {/* {isAuth ? null : (
            <Route
              path={`${process.env.PUBLIC_URL}/rolewiseReport`}
              element={<ProjectReportPage isAuth={isAuth} />}
            />
          )} */}
          {/* {isAuth ? null : (
            <Route
              path={`${process.env.PUBLIC_URL}/projectDetailsReport`}
              element={<ProjectDetailsReportPage isAuth={isAuth} />}
            />
          )} */}

          {/* Support */}
          <Route
            path={`${process.env.PUBLIC_URL}/support`}
            element={<Support />}
          />
        </Routes>
      </Fragment>
    </div>
  );
}
function PermissionRoute({ children, slug, ...rest }) {
  const permissionSelector = useSelector((state) => state.permission);
  const { response, isAdmin = false } = permissionSelector;
  // const isPermission = () =>
  //   isAdmin
  //     ? true
  //     : handleDetailResponse(
  //       handleListResponse(response).filter((i) => i.slug === slug)
  //     )?.permission;
  const isPermission = () => {
    if (isAdmin) {
      return true;
    }

    // Handle the case where slug can be an array or a single string
    const slugsToCheck = Array.isArray(slug) ? slug : [slug];

    // Check if the user has permission for any of the slugs
    return slugsToCheck.some(
      (slugItem) =>
        handleDetailResponse(
          handleListResponse(response).filter((i) => i.slug === slugItem)
        )?.permission
    );
  };
  return isPermission() ? children : <Navigate to="/unauthorized" />;
}
function AuthUsers() {
  return (
    <div className="page-wrapper">
      <Header />
      <div className="page-body-wrapper">
        <SideBar />
        <Routes>
          {/* Default Dashboard */}
          <Route
            path={`${process.env.PUBLIC_URL}/dashboard`}
            element={<Default />}
          />

          {/* <Route
            path={`${process.env.PUBLIC_URL}/newDashboard`}
            element={
              <PermissionRoute slug={"dashboard"}>
                <NewDashboard />
                </PermissionRoute>
            }
          /> */}
          <Route
            path={`${process.env.PUBLIC_URL}/newDashboard1`}
            element={
              <PermissionRoute slug={"dashboard1"}>
                <Dashboard1 />
              </PermissionRoute>
            }
          />
          {/* <Route
            path={`${process.env.PUBLIC_URL}/newDashboard2`}
            element={
              <PermissionRoute slug={"dashboard2"}>
                <Dashboard2 />
                </PermissionRoute>
            }
          /> */}
          {/* <Route
            path={`${process.env.PUBLIC_URL}/newDashboard3`}
            element={
              <PermissionRoute slug={"dashboard3"}>
                <Dashboard3 />
                </PermissionRoute>
            }
          /> */}

          <Route
            path={`${process.env.PUBLIC_URL}/viewuserprofile`}
            element={<ViewUserProfile />}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/edituserporfile`}
            element={<UserEditPorfile />}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/changepassword`}
            element={<ChangePassword />}
          />

          {/* User */}

          <Route
            path={`${process.env.PUBLIC_URL}/user/*`}
            element={
              <PermissionRoute slug={"user_management"}>
                <User />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/edituser/:user_id`}
            element={
              <PermissionRoute slug={"edit_user"}>
                <EditUser />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewuser/:user_id`}
            element={
              <PermissionRoute slug={"user_detail"}>
                <ViewUser />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addnewuser`}
            element={
              <PermissionRoute slug={"add_user"}>
                <AddNewUser />
              </PermissionRoute>
            }
          />

          {/* Property */}
          <Route
            path={`${process.env.PUBLIC_URL}/property`}
            element={
              <PermissionRoute slug={"property_management"}>
                <Property />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addnewproperty`}
            element={
              <PermissionRoute slug={"add_property"}>
                <AddNewProperty />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addnewpropertynext`}
            element={
              <PermissionRoute slug={"add_property"}>
                <AddNewPropNext />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/propertystepthird`}
            element={
              <PermissionRoute slug={"add_property"}>
                <PropertyStepThird />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/propertystepfourth`}
            element={
              <PermissionRoute slug={"add_property"}>
                <PropertyStepFourth />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editproperty/:property_id`}
            element={
              <PermissionRoute slug={"edit_property"}>
                <EditProperty />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editpropertynext/:property_id`}
            element={
              <PermissionRoute slug={"edit_property"}>
                <EditPropertyNext />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editpropertystepthird/:property_id`}
            element={
              <PermissionRoute slug={"edit_property"}>
                <EditPropertyStepThird />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editpropertystepfourth/:property_id`}
            element={
              <PermissionRoute slug={"edit_property"}>
                <EditPropertyStepFourth />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/viewproperty/:property_id`}
            element={
              <PermissionRoute slug={"view_property"}>
                <ViewProperty />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewnextproperty/:property_id`}
            element={
              <PermissionRoute slug={"view_property"}>
                <ViewPropertyNextPage />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/viewpropertynext/:doc_type/:property_id`}
            element={
              <PermissionRoute slug={"view_property"}>
                <ViewPropertyImage />
              </PermissionRoute>
            }
          />

          {/* Role */}
          <Route
            path={`${process.env.PUBLIC_URL}/roles`}
            element={
              <PermissionRoute slug={"role_management"}>
                <Roles />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editroles/:role_id`}
            element={
              <PermissionRoute slug={"edit_role"}>
                <EditRoles />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addnewroles`}
            element={
              <PermissionRoute slug={"add_role"}>
                <AddNewRoles />
              </PermissionRoute>
            }
          />

          {/* Module */}
          <Route
            path={`${process.env.PUBLIC_URL}/module`}
            element={
              <PermissionRoute slug={"module_management"}>
                <Module />
              </PermissionRoute>
            }
          />

          {/* Master */}
          <Route
            path={`${process.env.PUBLIC_URL}/master`}
            element={
              <PermissionRoute slug={"master_management"}>
                <Master />
              </PermissionRoute>
            }
          />

          {/* Channel Partner */}
          <Route
            path={`${process.env.PUBLIC_URL}/channelpartner`}
            element={
              <PermissionRoute slug={"channel_management"}>
                <ChannelPartner />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/allocateCpToSM`}
            element={
              <PermissionRoute slug={"channel_management"}>
                <CpSmList />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/cp_agent`}
            element={
              <PermissionRoute>
                <AgentList />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewchannelpartner/:_id`}
            element={
              <PermissionRoute slug={"view_channelpartner"}>
                <ViewChannelPartner />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/view_cpAgent/:_id`}
            element={
              <PermissionRoute slug={"view_cpAgent"}>
                <ViewAgentDetails />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/add_channel_partner`}
            element={
              <PermissionRoute slug={"add_channelpartner"}>
                <AddNewCP />
              </PermissionRoute>
            }
          />

          {/* Visitor */}
          <Route
            path={`${process.env.PUBLIC_URL}/visitor`}
            element={
              <PermissionRoute slug={"visitor_management"}>
                <Visitor />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewvisitor/:_id`}
            element={
              <PermissionRoute slug={"view_visitor"}>
                <ViewVisitor />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/bulk_Upload_Img_Csv`}
            element={
              <PermissionRoute slug={"bulk_upload"}>
                <BulkUploadImgCsv />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/upload_image`}
            element={
              <PermissionRoute slug={"bulk_upload"}>
                <UploadImage />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/upload_csv`}
            element={
              <PermissionRoute slug={"bulk_upload"}>
                <UploadCsv />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/visitor_form_second`}
            element={
              <PermissionRoute
                slug={
                  new URLSearchParams(window.location.search)
                    ? "edit_visitor"
                    : "add_visitor"
                }
              >
                <EditVisitor />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/visitor_form`}
            element={
              <PermissionRoute
                slug={
                  new URLSearchParams(window.location.search)
                    ? "edit_visitor"
                    : "add_visitor"
                }
              >
                <EditVisitorNext />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/visitor_form_third`}
            element={
              <PermissionRoute
                slug={
                  new URLSearchParams(window.location.search)
                    ? "edit_visitor"
                    : "add_visitor"
                }
              >
                <EditVisitorNext1 />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/visitor_form_draft`}
            element={
              <PermissionRoute
                slug={
                  new URLSearchParams(window.location.search)
                    ? "edit_visitor"
                    : "add_visitor"
                }
              >
                <EditVisitorNextDraft />
              </PermissionRoute>
            }
          />

          {/* Appointment */}
          <Route
            path={`${process.env.PUBLIC_URL}/appointment`}
            element={
              <PermissionRoute slug={"appointment_management"}>
                <Appointment />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/appointment_site_visit`}
            element={
              <PermissionRoute slug={"appointment_ site_visit"}>
                <AppointmentSiteVisit />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/today_appointments`}
            element={
              <PermissionRoute slug={"appointment_ site_visit"}>
                <TodayAppointment />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewappointment/:appointment_id`}
            element={
              <PermissionRoute
                slug={["view_appointment", "view_appointment _site_visite"]}
              >
                <ViewAppointment />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/revisit/:appointment_id`}
            element={
              <PermissionRoute slug={"appointment_management"}>
                <Revisit />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editappointment/:_id`}
            element={
              <PermissionRoute
                slug={["edit_appointment", "edit_appointment _site_visite"]}
              >
                <EditAppointment />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/add_appointment`}
            element={
              <PermissionRoute
                slug={["add_appointment", "add_appointment _site_visite"]}
              >
                <AddAppointment />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/update_appointment_status/:_id`}
            element={
              <PermissionRoute
                slug={[
                  "appointment_status_update",
                  "status_update_appointment _site_visite",
                ]}
              >
                <UpdateAppointmentStatus />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/appointment_with_cp`}
            element={
              <PermissionRoute slug={"appointment_with_cp"}>
                <CpAppointmentList />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/appointment-details`}
            element={
              <PermissionRoute slug={"appointment_with_cp"}>
                <AppointmentDetailsCp />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/add_appointment_with_cp`}
            element={
              <PermissionRoute slug={"appointment_with_cp"}>
                <AddAppointmentWithCp />
              </PermissionRoute>
            }
          />

          {/* New Upload */}
          <Route
            path={`${process.env.PUBLIC_URL}/newupload`}
            element={
              <PermissionRoute slug={"new_upload"}>
                <NewUpload />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createvisitor/:_id`}
            element={
              <PermissionRoute slug={"add_new_upload"}>
                <CreateVisitor />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createvisitornext/:_id`}
            element={
              <PermissionRoute slug={"add_new_upload"}>
                <CreateVisitorNext />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createvisitornext1/:_id`}
            element={
              <PermissionRoute slug={"add_new_upload"}>
                <CreateVisitorNext1 />
              </PermissionRoute>
            }
          />

          {/* Verify Lead*/}
          <Route
            path={`${process.env.PUBLIC_URL}/verify_lead`}
            element={
              <PermissionRoute slug={"verify_lead"}>
                <VerifyLead />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/view_verify_lead/:_id`}
            element={
              <PermissionRoute slug={"view_verify_lead"}>
                <ViewVerifyLead />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createLead/:_id`}
            element={
              <PermissionRoute slug={"add_verify_lead"}>
                <CreateLead />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createLeadnext/:_id`}
            element={
              <PermissionRoute slug={"add_verify_lead"}>
                <CreateLeadNext />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/createLeadnext1/:_id`}
            element={
              <PermissionRoute slug={"add_verify_lead"}>
                <CreateLeadNext1 />
              </PermissionRoute>
            }
          />

          {/* Chat Screen */}
          <Route
            path={`${process.env.PUBLIC_URL}/chat`}
            element={
              <PermissionRoute slug={"chat"}>
                <ChatScreen />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/chat_next`}
            element={
              <PermissionRoute slug={"chat"}>
                <ChatScreenNext />
              </PermissionRoute>
            }
          />

          {/* Followup */}
          <Route
            path={`${process.env.PUBLIC_URL}/followup`}
            element={
              <PermissionRoute slug={"followup_management"}>
                <FollowUp />
              </PermissionRoute>
            }
          />
          {/*Today Followup */}
          <Route
            path={`${process.env.PUBLIC_URL}/todayFollowup`}
            element={
              <PermissionRoute slug={"followup_management"}>
                <TodayFollowupIndex />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/allfollowup/:lead_id`}
            element={
              <PermissionRoute slug={"view_follow"}>
                <AllFollowUP />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewfollowup/:_id`}
            element={
              <PermissionRoute slug={"view_follow"}>
                <ViewFollowUp />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editfollowup/:_id`}
            element={
              <PermissionRoute slug={"edit_follow"}>
                <EditFollowup />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/updatestatusfollow/:lead_id`}
            element={
              <PermissionRoute slug={"edit_follow"}>
                <UpdateStatusFollow />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/updatestatusfollow/:lead_id/:appointment_id`}
            element={
              <PermissionRoute slug={"edit_follow"}>
                <AppointmentFollowup />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/scheduled_activity`}
            element={
              <PermissionRoute slug={"scheduled_activity"}>
                <ScheduledActivityFollowup />
              </PermissionRoute>
            }
          />

          {/* Support Forum */}
          <Route
            path={`${process.env.PUBLIC_URL}/supportforum`}
            element={
              <PermissionRoute slug={"support_forum"}>
                <SupportForum />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addnewsupportforum`}
            element={
              <PermissionRoute slug={"add_support_forum"}>
                <AddNewSupportForum />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/editsupportforum/:support_forum_id`}
            element={
              <PermissionRoute slug={"edit_support_forum"}>
                <EditSupportForum />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/viewsupportforum/:support_forum_id`}
            element={
              <PermissionRoute slug={"view_support_forum"}>
                <ViewSupportForum />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/ViewSupportForumGallary/:doc_type/:support_forum_id`}
            element={
              <PermissionRoute slug={"view_support_forum"}>
                <ViewSupportForumGallary />
              </PermissionRoute>
            }
          />

          {/* Support Ticket */}
          <Route
            path={`${process.env.PUBLIC_URL}/raise_ticket`}
            element={
              <PermissionRoute slug={"support"}>
                <SupportTicket />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/support_request`}
            element={
              <PermissionRoute slug={"support"}>
                <SupportRequest />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/view_raise_ticket`}
            element={
              <PermissionRoute slug={"support_ticket_details"}>
                <ViewSupportTicket />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/updatestatus`}
            element={
              <PermissionRoute slug={"update_ticket_status"}>
                <UpdateStatus />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/edit_reply_ticket`}
            element={
              <PermissionRoute slug={"update_ticket_status"}>
                <EditReplyTicket />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/raise_ticket_form`}
            element={
              <PermissionRoute slug={["edit_raise_ticket", "add_raise_ticket"]}>
                <AddEditRaiseTicket />
              </PermissionRoute>
            }
          />

          {/* Configuration_setting */}
          <Route
            path={`${process.env.PUBLIC_URL}/configurationEmail`}
            element={
              <PermissionRoute slug={"configuration_management"}>
                <ConfigurationEmail />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/configurationMessage`}
            element={
              <PermissionRoute slug={"configuration_management"}>
                <ConfigurationMessage />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/NotificationMapKey`}
            element={
              <PermissionRoute slug={"configuration_management"}>
                <NotificationMapKey />
              </PermissionRoute>
            }
          />

          {/* Booking */}
          <Route
            path={`${process.env.PUBLIC_URL}/booking_list`}
            element={
              <PermissionRoute slug={"booking_management"}>
                <BookingList />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/cancel_booking_list`}
            element={
              <PermissionRoute slug={"cancel_booking"}>
                <CancelBookingList />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/view_booking/:booking_id`}
            element={
              <PermissionRoute slug={"view_booking"}>
                <ViewBooking />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/addBooking/:lead_id/:appointment_id`}
            element={
              <PermissionRoute slug={"booking_management"}>
                <AddBooking />
              </PermissionRoute>
            }
          />
          {/* Report_management */}
          <Route
            path={`${process.env.PUBLIC_URL}/pdr_report`}
            element={
              <PermissionRoute slug={"project_details_report"}>
                <PdrReport />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/reports`}
            element={
              <PermissionRoute slug={"report"}>
                <ReportUser />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/report`}
            element={
              <PermissionRoute slug={"report"}>
                <ReportDetail isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/kpi_tracker_report`}
            element={
              <PermissionRoute slug={"report_manage"}>
                <ReportManage isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/user_activity_report`}
            element={
              <PermissionRoute slug={"report"}>
                <UserActivityReport isAuth={true} />
              </PermissionRoute>
            }
          />
          {/* <Route
            path={`${process.env.PUBLIC_URL}/rolewiseReport`}
            element={
              <PermissionRoute slug={"rolewiseReport"}>
                <ProjectReportPage isAuth={true} />
              </PermissionRoute>
            }
          /> */}
          <Route
            path={`${process.env.PUBLIC_URL}/projectDetailsReport`}
            element={
              <PermissionRoute slug={"report"}>
                <ProjectDetailsReportPage isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/dispositionReport`}
            element={
              <PermissionRoute slug={"report"}>
                <DepositonReport isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/getChannelPartnerAppointments`}
            element={
              <PermissionRoute slug={"report"}>
                <CpAppointmentReport isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/ChannelPartnerAppointmentsList`}
            element={
              <PermissionRoute slug={"report"}>
                <ChannelPartnerAppointmentReport isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/ChannelPartnerReport`}
            element={
              <PermissionRoute slug={"report"}>
                <ChanelPartnerReport isAuth={true} />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/closing_managers`}
            element={
              <PermissionRoute slug={"closing_manager"}>
                <ClosingManagerList />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/viewClosingManager/:_id`}
            element={
              <PermissionRoute slug={"closing_manager_detail"}>
                <ClosingManagerDetails />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/sourcing_managers`}
            element={
              <PermissionRoute slug={"sourcing_manager"}>
                <SourcingManagerList />
              </PermissionRoute>
            }
          />

          <Route
            path={`${process.env.PUBLIC_URL}/viewSourcingManager/:_id`}
            element={
              <PermissionRoute slug={"sourcing_manager"}>
                <SourcingManagerDetails />
              </PermissionRoute>
            }
          />

          {/* Registration */}
          <Route
            path={`${process.env.PUBLIC_URL}/registration`}
            element={
              <PermissionRoute slug={"registration_management"}>
                <Registration />
              </PermissionRoute>
            }
          />
          <Route
            path={`${process.env.PUBLIC_URL}/view_registration/:registration_id`}
            element={
              <PermissionRoute slug={"view_registration"}>
                <ViewRegistration />
              </PermissionRoute>
            }
          />

          {/* Edit Privacy Policy  */}
          <Route
            path={`${process.env.PUBLIC_URL}/edit_privacypolicy`}
            element={
              <PermissionRoute slug={"privacypolicy"}>
                <PrivacyPolicyUpdate />
              </PermissionRoute>
            }
          />

          {/* User_Announcement */}
          <Route
            path={`${process.env.PUBLIC_URL}/user_announcement`}
            element={
              <PermissionRoute slug={"user_announcement"}>
                <UserAnnouncement />
              </PermissionRoute>
            }
          />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default Routers;
